"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableArray = void 0;
const decorators_1 = require("../decorators");
const lib_1 = require("../lib");
const observable_collection_1 = require("./observable-collection");
let ObservableArray = class ObservableArray extends observable_collection_1.ObservableCollection {
    constructor(itemsOrLength) {
        super();
        if (typeof (itemsOrLength) === 'number') {
            this.array = new Array(itemsOrLength);
        }
        else if (itemsOrLength) {
            this.array = Array.from(itemsOrLength);
        }
        else {
            this.array = [];
        }
    }
    at(index) {
        return this.array[index < 0 ? this.array.length + index : index];
    }
    push(element) {
        this.array.push(element);
        this._changed();
    }
    pushAll(elements) {
        const preLength = this.array.length;
        this.array.push(...elements);
        if (preLength !== this.array.length) {
            this._changed();
        }
    }
    pop() {
        if (this.array.length === 0) {
            return undefined;
        }
        const element = this.array.pop();
        this._changed();
        return element;
    }
    unshift(element) {
        this.array.unshift(element);
        this._changed();
    }
    unshiftAll(elements) {
        const preLength = this.array.length;
        this.array.unshift(...elements);
        if (preLength !== this.array.length) {
            this._changed();
        }
    }
    shift() {
        if (this.array.length === 0) {
            return undefined;
        }
        const element = this.array.shift();
        this._changed();
        return element;
    }
    sort() {
        if (!this.array.length) {
            return;
        }
        this.array.sort();
        this._changed();
    }
    reverse() {
        if (!this.array.length) {
            return;
        }
        this.array.reverse();
        this._changed();
    }
    splice(start, deleteCount, ...elements) {
        this.array.splice(start, deleteCount, ...elements);
        this._changed();
    }
    get length() {
        return this.array.length;
    }
    set length(nextLength) {
        if (this.array.length === nextLength) {
            return;
        }
        this.array.length = nextLength;
        this._changed();
    }
    /**
     * Remove all elements from the array.
     */
    clear() {
        if (!this.array.length) {
            return;
        }
        this.length = 0;
        this._changed();
    }
    /**
     * Replace all elements in the array.
     * @param elements
     */
    replace(elements) {
        this.array.length = 0;
        this.array.push(...elements);
        this._changed();
    }
    includes(el, fromIndex) {
        return this.array.includes(el, fromIndex);
    }
    some(predicate) {
        return this.array.some((element, index) => predicate(element, index, this));
    }
    every(predicate) {
        return this.array.every((element, index) => predicate(element, index, this));
    }
    find(predicate) {
        return this.array.find((element, index) => predicate(element, index, this));
    }
    findIndex(predicate) {
        return this.array.findIndex((element, index) => predicate(element, index, this));
    }
    findLast(predicate) {
        for (let i = this.array.length - 1; i >= 0; --i) {
            const element = this.array[i]; // eslint-disable-line @typescript-eslint/no-non-null-assertion
            if (predicate(element, i, this)) {
                return element;
            }
        }
        return undefined;
    }
    findLastIndex(predicate) {
        for (let i = this.array.length - 1; i >= 0; --i) {
            const element = this.array[i]; // eslint-disable-line @typescript-eslint/no-non-null-assertion
            if (predicate(element, i, this)) {
                return i;
            }
        }
        return -1;
    }
    [Symbol.iterator]() {
        return this.array[Symbol.iterator]();
    }
    entries() {
        return this.array.entries();
    }
    forEach(callback) {
        this.array.forEach((element, index) => callback(element, index, this));
    }
    filter(predicate) {
        return this.array.filter((element, index) => predicate(element, index, this));
    }
    flat(depth) {
        return this.array.flat(depth);
    }
    flatMap(fn) {
        return this.array.flatMap((value, index) => fn(value, index, this));
    }
    map(fn) {
        return this.array.map((value, index) => fn(value, index, this));
    }
    reduce(fn, initialValue) {
        return this.array.reduce((previousValue, currentValue, index) => (fn(previousValue, currentValue, index, this)), initialValue);
    }
    reduceRight(fn, initialValue) {
        return this.array.reduceRight((previousValue, currentValue, index) => (fn(previousValue, currentValue, index, this)), initialValue);
    }
    slice(start, end) {
        return this.array.slice(start, end);
    }
    join(separator) {
        return this.array.join(separator);
    }
    toString() {
        return this.array.toString();
    }
    toLocaleString() {
        return this.array.toLocaleString();
    }
    toArray() {
        return this.array.slice(0);
    }
    observe(callback, options) {
        lib_1.SubjectInstance.get(this).observe(callback, options);
    }
    unobserve(callback) {
        lib_1.SubjectInstance.get(this).unobserve(callback);
    }
};
ObservableArray = __decorate([
    (0, decorators_1.subject)()
], ObservableArray);
exports.ObservableArray = ObservableArray;
//# sourceMappingURL=observable-array.js.map